import { render, staticRenderFns } from "./roleSelect.vue?vue&type=template&id=53de42c4&"
import script from "./roleSelect.vue?vue&type=script&lang=js&"
export * from "./roleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports